/* eslint no-undef: 0 */  // --> OFF
/* eslint no-unused-vars: 0 */
/* global mapboxgl, cheapRuler */

// mapbox find a program mechanisms

$(document).ready(function() {
    /***********
     * variable declarations
     */
    const mapapikey = 'pk.eyJ1Ijoia29yZ3JvdXAiLCJhIjoiY2p0ZWs1d2d5MTQzcjQ1bXU1MDV1bThnZCJ9.cPmiVP6cKofY8CDm3Laebw';
    mapboxgl.accessToken = 'pk.eyJ1Ijoia29yZ3JvdXAiLCJhIjoiY2p0ZWs1d2d5MTQzcjQ1bXU1MDV1bThnZCJ9.cPmiVP6cKofY8CDm3Laebw';
    datasetid = 'cjv4dvcsm5xml2rmtuwfxx39d';
    var miles_5 = 8046;
    var miles_10 = 16093;
    var miles_15 = 24140;
    var querylimit = 100; // the limit of how many queries to submit to the endpoint. NOTE should match PHP limit;
    var errorMsgTooMany = '+ sites located. Narrow your selection for more precise results.';
    let theList = jQuery.find('#map-results');
    const theCloseButton = jQuery('#map--ui-close-results-button'); // mobile close results
    const resultsOverlay = jQuery('#map-results-overlay');
    const distanceVal = jQuery('#map--ui-radius-select option:selected').val(); // doesnt update, has to be duplicated
    const noResultString = 'No results found in this search. Try a larger search radius.';
    const mapEl = jQuery('#map');

    var drawbbox = false; // debugger boxes.
    window.bboxpopups = []; // global. array to hold debugger boxes
    window.markerclick = []; // global. either empty array or one marker.
    window.coords = ''; // global for current coords so distance thing can know what to run.

    // myror URL structure vars
    var donateURL = '/donate-books-to-reach-out-and-read/?siteid=';
    var voluntURL = '/volunteer-form/?siteid=';
    var mapresultdonate = '.map-result-donate-true'; // classes to detect
    var mapresultvolunt = '.map-result-volunt-true'; // classes to detect


    /*************
     * utility functions
     */
    /**
     * converts to string
     * @param selector
     * @returns {*|jQuery}
     */
    function htmlToSource(selector){
        return $('<div />').append($(selector).clone()).html();
    }

/*    $(document).on('load, resize', function() {
        console.log('load or resize');
    });*/

    /**
     * map-result-donate-true handler
     * browser exits this location.
     * event handlers "on click" binding at clicktime due to new dom elements.
     */
    $(document).on('click', mapresultdonate, function() {
        // console.log('mapresultdonate newtab', this);
        var targ = jQuery(this).parent().attr('data-site_id');

        var redirectWindow = window.open(donateURL + targ, '_blank');
        redirectWindow.location;
        //window.location.href = donateURL + targ;
    });

    /**
     * map-result-volunt-true handler
     * browser exits this location.
     * event handlers "on click" binding at clicktime due to new dom elements.
     */
    $(document).on('click', mapresultvolunt, function() {
        // console.log('mapresultvolunt newtab', this);
        var targ = jQuery(this).parent().attr('data-site_id');
        var redirectWindow = window.open(voluntURL + targ, '_blank');
        redirectWindow.location;
        //window.location.href = voluntURL + targ;
    });

    /**
     * close search box click handler mobile only.
     */
    theCloseButton.on('click',function() {
        hideSearchResults();
    });

    /**
     * hide dom elements by toggling class
     */
    function hideSearchResults() {
        jQuery(theList).removeClass('is-active');
        resultsOverlay.removeClass('is-active');
        theCloseButton.removeClass('is-active');

        mapEl.removeClass('listings-active').focus(); // prevents focus bounce to searchbox. seems to work.
    }

    /**
     * show dom elements by toggling class
     */
    function showSearchResults() {
        jQuery(theList).addClass('is-active');
        resultsOverlay.addClass('is-active');
        theCloseButton.addClass('is-active');
        mapEl.addClass('listings-active').focus(); // prevents focus bounce to searchbox. seems to not work
        if (Foundation.MediaQuery.is('small only')) { //only scroll on mobile.
            var element = document.getElementById('map-results');
            element.scrollIntoView();
        }
    }

    /**
     * change things upon selecting distance.
     * should refetch from API upon change.
     */
    jQuery('#map--ui-radius-select').on('change', function() {
        // console.log('radius changed');
        // var zoomlevel = setMapZoombyDistance();
        //geocoder.setZoom(zoomlevel);
        if (window.coords === '') {
          console.log('no coord lock');
            return;
        }
        var distance = jQuery('#map--ui-radius-select option:selected').val();
        var targetzoom = parseInt( setMapZoombyDistance());
        // console.log(targetzoom);
        window.map.setZoom(targetzoom);
        // console.log(map);
        // console.log('radius change: ', window.coords, distance);
        getList(map, window.coords, distance);
    });


    /**
     * debuggers to add and and subtract debug popups.
     * @param coord
     */
    function drawBoundingBox(coord) {
        var popup1 = new mapboxgl.Popup() // placeholder popup
            .setLngLat(coord)
            .setHTML('bbox')
            .addTo(map);

        window.bboxpopups.push(popup1);
    }

    function clearBoundingBox() {
        // console.log(window.bboxpopups);
        if (window.bboxpopups.length > 0) {
            window.bboxpopups.forEach(function(el) {
                el.remove();
            });
        }
    }
    window.clearbb = clearBoundingBox;

    /**
     * clears the click derived blue markers.
     */
    function clearMarker() {
        if (!Array.isArray( window.markerclick )) {
            // console.log('isnt empty array');
            window.markerclick.remove();
        }
    }

    /**
     * todo this should run more often. like on each time the distance dial gets changed.
     * @returns {number}
     * this will use the setZoom of the geocoder obj
     */
    function setMapZoombyDistance() {
        var distance = jQuery('#map--ui-radius-select option:selected').val(); // from jquery.
        var zoom = 0;
        // console.log('setMapZoombyDistance', distance);
        switch(distance) { // is a string not an int.
            case '5':
                return 11;
            case '10':
                return 9;
            case '25':
                return 9;
            case '50':
            default:
                return 8;
            case '100':
                return 7;
            case '150':
                return 6;
            case '200':
                return 5;
        }
    }

    /*************
     *  initialize Map. adds the map to page
     */
    const map = new mapboxgl.Map({
        container: 'map', // container id specified in the HTML ( aka mapEl )
        style: 'mapbox://styles/mapbox/dark-v10',        // style URL
        center: [-98.5556199, 39.8097343], // initial position in [lon, lat] format
        zoom: 3,        // initial zoom
    });

    window.map = map;

    map.scrollZoom.disable();
    $(document).on('click', '#map--ui-go', function(e) {
        e.preventDefault();
        // todo re run the coder here
    });

    /**
     * map setup and controls initialized.
     */
    map.on('load', function () {
// this value is passed via the page-14 PHP template file and is an inline variable.
        const localFileURL = latlongfile_url; // '/wp-content/uploads/mapdata/siteid-lat-long.geojson';
        map.addLayer({ // adds layer w geojson sites. from local file URL.
           'id' : 'clean-allsites',
           'type' : 'circle',
            'layout': {
                'visibility': 'visible',
            },
            // see 'camera expressions'
            // https://docs.mapbox.com/mapbox-gl-js/style-spec/
            'paint': {
               'circle-radius': [
                   'interpolate', ['linear'], ['zoom'],
                   10, 2,
                   13, 8,
               ],
               // 'circle-radius': 2,
                'circle-color': 'rgba(55,148,179,0.8)',
            },
            'source': {
                'type': 'geojson',
                'data': localFileURL,
            },
        });
        map.addControl(new mapboxgl.NavigationControl()); // nav control arrows.
// When a click event occurs on a feature in the places layer, open a popup at the
// location of the feature, with description HTML from its properties.
        map.on('click', 'clean-allsites', function (e) {
            var coordinates = e.features[0].geometry.coordinates.slice();
            var description = e.features[0].properties.description;
// Ensure that if the map is zoomed out such that multiple
// copies of the feature are visible, the popup appears
// over the copy being pointed to.
            while (Math.abs(e.lngLat.lng - coordinates[0]) > 180) {
                coordinates[0] += e.lngLat.lng > coordinates[0] ? 360 : -360;
            }
// catch for the popups.
//             console.log('clicked feature : ', e.features[0]);
            generateMapPopup(e, map);
        });
// Change the cursor to a pointer when the mouse is over the places layer.
        map.on('mouseenter', 'clean-allsites', function () {
            map.getCanvas().style.cursor = 'pointer';
        });
// Change it back to a pointer when it leaves.
        map.on('mouseleave', 'clean-allsites', function () {
            map.getCanvas().style.cursor = '';
        });
    });

    /**
     * click handler on map in general.
     * gets a location around the clicked point. collects UI distance val from element via jquery
     */
    map.on('click', function(e) {
        // console.log('maponclick coord:', e.lngLat);
        var distance = jQuery('#map--ui-radius-select option:selected').val();
        var ruler = cheapRuler(e.lngLat.lat, 'miles');
        // console.log('onclick ruler', ruler);
        var bbox = ruler.bufferPoint([e.lngLat.lng, e.lngLat.lat], distance); // bbox : w s e n are geo vals array
        // console.log('maponclick: bbox from ruler bufferpoints', bbox, e.lngLat, distance);
        var bbox_pixel_sw = map.project([bbox[0],bbox[1]]);// long, lat // translate from geospatial to pixels
        var bbox_pixel_ne = map.project([bbox[2],bbox[3]]);

        var featureset = map.queryRenderedFeatures([bbox_pixel_sw, bbox_pixel_ne], { layers: ['clean-allsites'] });
        // console.log('mapOnClick', e, bbox, featureset); //todo remove
        clearBoundingBox(); // clears extra markers in case.
        if (drawbbox) {
            drawBoundingBox([bbox[0],bbox[1]]);
            drawBoundingBox([bbox[2],bbox[3]]);
        }
        map.flyTo({center: e.lngLat});
        window.coords = e.lngLat;
        geocoder.clear(); // clear the geocoder. after map clicks.
        clearMarker(); // remove old click marker.
        var marker = new mapboxgl.Marker()
            .setLngLat(e.lngLat)
            .addTo(map);
        window.markerclick = marker;
        retrieveLocationListJSON( featureset, e.lngLat, distance );
    });

    /**
     * geocoder controller.
     * @type {MapboxGeocoder}
     */
    var geocoder = new MapboxGeocoder({
        accessToken: mapboxgl.accessToken,
        mapboxgl: mapboxgl,
        countries: 'us PH tw it',
        zoom: setMapZoombyDistance(), // todo . okay but this does not recur enough/
        placeholder: 'Address:',
        flyTo: { // cleans up the speed of it. snaps to destination quick.
            bearing: .75,
            speed: 5,
            curve: .9,
        },
    });
    // attaches geocoder widget to correct spot
    document.getElementById('geocoderwidget').appendChild(geocoder.onAdd(map));

    // event as the address is typed to geocoder. occurs several times. (gets sent to populate dropdowns
    // geocoder.on('loading', function(ev){
        // console.log('loading> ', ev); //todo remove
    // });

    /**
     * Event when Geocoder address gets processed and returned from mapbox.
     */
    geocoder.on('result', function(e){
        // console.log('result> ', e, e.result.center); // todo remove
        // console.log('ResultEvent Coords', e.result.geometry.coordinates);
        var coords = e.result.geometry.coordinates; // 0 is long, 1 is lat.
        // coded_lat = ev.result.geometry.coordinates[1];
        // coded_long = ev.result.geometry.coordinates[0];
        // console.log('lat', coded_lat, 'long', coded_long);

        // get mile value from the dropdown box.
        var distance = jQuery('#map--ui-radius-select option:selected').val();

        //getlist begins list gathering. fetch is delayed 1700.
        window.coords = coords;
        delayedCheck = setTimeout(getList, 1700, map, coords, distance );
        clearMarker(); // remove old click marker.

        showSearchResults();
        jQuery('#map-spinner').addClass('is-active');
    });

    /**
     * GetList function creates boundingbox from distance + coords then makes JSON request
     * it creates the set of feature ids from queryRenderedFeatures based on pixel boundingbox.
     * @param map
     * @param target longlat
     * @param distance mile integer
     */
    function getList(map, target, distance) {
        var ruler = '';
        // console.log('getlist targ/distance', target, distance);
        if (target.hasOwnProperty('lat')) {
            newtarg = [target.lng, target.lat];
            target = newtarg;
            //ruler = cheapRuler(target.lat, 'miles');
        }

        ruler = cheapRuler(target[1], 'miles');

        // console.log('getlist targ/distance/ruler:', target, distance, ruler);
        // var testdistance = ruler.distance([30.51, 50.32], [30.52, 50.312]);
        // console.log('testdistance', testdistance);
        var bbox = ruler.bufferPoint(target, distance); // bbox : w s e n are geo vals array
        // console.log('GetList: bbox from ruler bufferpoints', bbox, target, distance);
        var bbox_pixel_sw = map.project([bbox[0],bbox[1]]);// long, lat
        var bbox_pixel_ne = map.project([bbox[2],bbox[3]]);

        // console.log(bbox_pixel_sw, bbox_pixel_ne);
        if (drawbbox) {
            drawBoundingBox([bbox[0],bbox[1]]);
            drawBoundingBox([bbox[2],bbox[3]]);
        }

        var targ = map.project(target);
        //console.log('getList targ=', targ, e);

        // var bbox = [[targ.x - tr, targ.y - tr], [targ.x + tr, targ.y + tr]];
        //         var features = map.queryRenderedFeatures(bbox, { layers: ['clean-allsites'] });
        var features = map.queryRenderedFeatures([bbox_pixel_sw, bbox_pixel_ne], { layers: ['clean-allsites'] });
        // console.log('GetList: features from bbox', features, bbox, target, distance);
        retrieveLocationListJSON(features, target, distance);
    }

    // webpack bug  https://github.com/mapbox/mapbox-gl-js/issues/3265
    // map.on('render', function() {
    //     map.resize();
    // });

    /**
     * retrieves list of locations based on latitude, longitude and distance.
     *
     * @param featureset
     * @param target
     * @param distance
     */
    function retrieveLocationListJSON(featureset, target, distance ) {
        // console.log('retrieveLocationListJSON', distance, featureset, target);
        var url='/wp-json/ror_wp/v1/findprogram/';
        var listof_ids = [];
        if (Array.isArray(featureset)) {
            featureset.forEach(function(el) {
                if (listof_ids.length < querylimit) {
                    listof_ids.push(el.properties.site_id);
                }
            });
            var dataset = distance + ',' + listof_ids.join();
        }
        else {
            // console.log('no featureset. return');
            renderLocationList(false, false);
            // should render a no sites message. renderLocationList
            return;
        }
        // console.log('retrieveLocationListJSON submit:', dataset);
        url = url+dataset; // remote URL with querystring.
        //activate result box
        showSearchResults();
        jQuery('#map-spinner').addClass('is-active');
        // asynchronous veers off
        jQuery.getJSON(url, '', function(data) {
            // console.log('JSON return data' , data);
            renderLocationList(data, distance, target);
        } );
        // execution continues.
    }

    /**
     * selects the dom elements and inserts JSON results into the DOM.
     * @param jsonPayload
     * @param distance
     * @param target can be array or longlat object
     */
    function renderLocationList(jsonPayload, distance, target) {
        // console.log('map is', map);
        var totalRendered = 0; // tally if zero or not
        jQuery('#map-spinner').removeClass('is-active');
        if (Array.isArray(target)) { // cleans up object type.
            target = {lng: target[0], lat: target[1]};
            // console.log('target was array/ now: ', target);
        }
        // console.log('renderLocationList targ', target, target.lng, target.lat);
        var targLng = Math.round(target.lng * 100000) / 100000;
        var targLat = Math.round(target.lat * 100000) / 100000;
        ruler = cheapRuler(targLat, 'miles');

        let theEls = ''; // response elements.
        // payload is false if no hits.
        //console.log('jsonpayload: # ', jsonPayload.length, 'data:', jsonPayload);
        // console.log('jsonpayload: # ', jsonPayload.length);
        if ( jsonPayload.length === querylimit ) {
            alert(querylimit + errorMsgTooMany);
        }
        if (jsonPayload.length === 0) {
            // console.log('renderLocationList no result');
            theEls = jQuery('<div />', { 'class': 'map-noresult', 'html': noResultString});
        } else {
            theEls = document.createDocumentFragment(); // stub to assemble the el

            var PayloadObj = jsonPayload; //JSON.parse(jsonPayload);
            var locdistance = 0;
            PayloadObj.forEach(function(loc) {
                // console.log('ruler params',[loc.Longitude, loc.Latitude], [targLng, targLat]);
                locdistance = ruler.distance([loc.Longitude, loc.Latitude], [targLng, targLat]);
                // distance = Math.round(target.lat * 100) / 100;
                // console.log(distance);
                locdistance =  Math.round(locdistance * 100) / 100; // hundredsths of the mile.
                // console.log(distance);
                loc.distance = locdistance;
                //console.log('miles', distance, [loc.Longitude, loc.Latitude], target, target.lng, target.lat);
            });

            PayloadObj.sort(function(a, b) { // sort the JS objects by distance
                return a.distance - b.distance;
            });

            PayloadObj.forEach(function(loc) {
                // console.log(loc);
                // console.log(loc.distance);
                if (loc.distance < distance) {
                    totalRendered++;
                    var el = assembleDOMchunkfromJSON(loc, false);
                    jQuery(theEls).append(el);
                }
            });
        }
        // replace the contents of the list el with these Els. if got zero, give no result (in case one came in bbox but was outside radius calc
        if (totalRendered === 0) {
            theEls = jQuery('<div />', { 'class': 'map-noresult', 'html': noResultString});
        }
        jQuery(theList).addClass('is-active').html(theEls);

    }

    /**
     * json endpoint fetcher
     * @param feature
     */
    function retrieveSingleLocationJSON(feature) {
        // console.log('retrieveSingleLocationJSON', feature);
        var url='/wp-json/ror_wp/v1/findsingleprogram/';
    }

    /**
     * site els get returned as HTML chunk.
     * @param loc the location elements.
     * @param isPopup boolean
     */
    function assembleDOMchunkfromJSON(loc, isPopup) {
        var el = jQuery('<div />', {'class' : 'map-result'} ).attr('data-site_id',loc.site_id);
        // scratch trailing slash from sitename
        loc.sitename = loc.sitename.replace(/\/$/, '');
        var el_sitename = jQuery('<div />', {'class' : 'map-result-sitename', 'text' : loc.sitename });
        // compose the address
        var siteloc = ''; // postal address string.
        var donate = false;
        var volunt = false;
        var el_tel;
        siteloc += loc.physical_1;
        if (loc.physical_2.length > 0) {
            siteloc += ', ' + loc.physical_2;
        }
        siteloc += ' ' + loc.city + ', ';
        siteloc += loc.state + ' ';
        siteloc += loc.zip.substring(0 ,5); // cutoff long zip
        var el_siteloc1 = jQuery('<div />', {'class' : 'map-result-addr', 'text' : siteloc});
        // this to be replaced with distances from array.
        var el_distance = '';
        if (!isPopup) {
            if (loc.distance === 1) {
                el_distance = jQuery('<div />', {'class': 'map-result-distance', 'text': loc.distance + ' mile'});
            } else {
                el_distance = jQuery('<div />', {'class': 'map-result-distance', 'text': loc.distance + ' miles'});
            }
        }
        if ( loc.primary_phone == null) {
          el_tel = jQuery('<div />', {'class': 'map-result-tel'});
        } else if ( loc.primary_phone.length < 1) {
          el_tel = jQuery('<div />', {'class': 'map-result-tel'});
        } else {
            el_tel = jQuery('<div />', {'class' : 'map-result-tel', 'text': 'Tel: ' + loc.primary_phone});
        }
        if (loc.site_donations === 'Y') {
            donate = true;
        }
        if (loc.site_volunteers === 'Y') {
            volunt = true;
        }
        var el_donate = jQuery('<div />', {'class' : 'map-result-donate-' + donate });
        var el_volunt = jQuery('<div />', {'class' : 'map-result-volunt-' + volunt });
        // put together the els , do not include distance for popup clicks.
        if (isPopup) {
            jQuery(el).append(el_sitename).append(el_siteloc1).append(el_tel).append(el_donate).append(el_volunt);

        } else {
            jQuery(el).append(el_sitename).append(el_siteloc1).append(el_distance).append(el_tel).append(el_donate).append(el_volunt);
        }
        return el;
    }

    /**
     * show popups from click.
     * @param e
     * @param map
     */
    function generateMapPopup(e, map) {
        // console.log('gen map popup', e, map);
        var url='/wp-json/ror_wp/v1/findsingleprogram/';
        var cbr = 2; // clickboxradius
        var bbox = [[e.point.x - cbr, e.point.y - cbr], [e.point.x + cbr, e.point.y + cbr]];
        var coordinates = e.features[0].geometry.coordinates.slice();
        var popupcontents = 'Loading...';
        var loadingpopup = new mapboxgl.Popup() // placeholder popup
            .setLngLat(coordinates)
            .setHTML(popupcontents)
            .addTo(map);
        // var features = map.queryRenderedFeatures(bbox, { layers: ['clean-allsites'] });
        var features = e.features[0];
        url = url + features.properties.site_id;
        // console.log('popup query features, url', features, url);

        theEls = document.createDocumentFragment(); // stub to assemble the el

        // JSON request to get single site info.
        jQuery.getJSON(url, '', function(data) {
            // console.log('singlepayload', data);

            var el = assembleDOMchunkfromJSON(data, true);

            jQuery(theEls).append(el);
            // console.log(theEls);
            // converts to string
            var resultsitehtml = htmlToSource(theEls);
            loadingpopup.remove();
//mapboxgl does exist as a global.
            new mapboxgl.Popup()
                .setLngLat(coordinates)
                .setHTML(resultsitehtml)
                .addTo(map);
        } );
    }
});



// WEBPACK FOOTER //
// ./scripts/findprogram.js